<template>
  <div>
    <div class="empty-data">
      <div>
        <img :src="getAssetsFile('home/No_record@2x.png')" alt=""  class="max-h-[84px] max-w-[106.5px] w-auto h-auto">
      </div>

      <div class="empty-text">{{ t('relatorios.other.noRecords') }}</div>
    </div>
  </div>

</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { getAssetsFile } from '@/utils/pub-use'

const { t } = useI18n()
</script>
<style scoped>
.empty-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 115px;
}

.empty-text {
  color: #ADB1B0;
  font-size: 11px;
  margin-top: 21px;
}
</style>
